export default __webpack_public_path__ + "static/media/check.21aecc88.svg";